export const skills = [
  "Apache Spark (Scala/Python)",
  "Databricks (Delta + UC)",
  "AWS (S3, Glue, Athena)",
  "Azure (ADLS, Databricks)",
  "Terraform / IaC",
  "Argo Workflows",
  "Streaming (NATS/Kafka)",
  "SQL · Data Modeling",
  "Data Governance & Privacy",
  "Python · Scala"
]
